/* eslint-disable react/no-unknown-property */

/**
 * https://drei.pmnd.rs/?path=/docs/staging-stage--docs
 */
import { useRef, Suspense } from 'react'
import { Canvas } from '@react-three/fiber'
import { OrbitControls, Stage, Html, useProgress } from '@react-three/drei'
import { Spin } from 'antd'
// import GLTFModel from './GLTFModel'
import PLYModel from './PLYModel'

function Progress() {
  // const { progress } = useProgress()
  return (
    <Html wrapperClass="w-full h-full">
      <Spin size="small" />
    </Html>
  )
}

const ThreeModelViewer = ({ source, type }) => {
  // console.log(source, '------------------')
  const ref = useRef()

  return (
    /**
     * Canvas 组件是一个画布，用来放置 3D 元素
     * @shadows: 是否开启阴影，默认是 false
     * @dpr: 渲染器的设备像素比，默认是 2
     * @camera.position：相机位置，默认是 (0, 0, 10)
     * @camera.fov：相机视锥体垂直视野角度 默认是 45
     * camera.near：相机视锥体近端面，默认是 0.1
     * camera.far：相机视锥体远端面，默认是 1000
     * @pixelRatio：像素比，默认是 1
     * @antialias：是否开启抗锯齿，默认是 false
     * @onCreated：画布创建时的回调函数
     * @onPointerMissed：画布点击时的回调函数
     * @onPointerDown：画布鼠标按下时的回调函数
     * @onPointerUp：画布鼠标抬起时的回调函数
     * @onPointerMove：画布鼠标移动时的回调函数
     * @onPointerOver：画布鼠标移入时的回调函数
     * @onPointerOut：画布鼠标移出时的回调函数
     * @onDoubleClick：画布鼠标双击时的回调函数
     * @onWheel：画布鼠标滚轮滚动时的回调函数
     * @onContextMenu：画布鼠标右键点击时的回调函数
     * @onKeyDown：画布键盘按下时的回调函数
     * @onKeyUp：画布键盘抬起时的回调函数
     * @onKeyPress：画布键盘按下时的回调函数
     * @onBlur：画布失去焦点时的回调函数
     * @onFocus：画布获得焦点时的回调函数
     * @onCreated：画布创建时的回调函数
     */

    /**
     * Stage 组件是一个容器，用来放置模型
     * @controls：控制器，可以通过 ref 来获取
     * @intensity: 环境光强度，默认是 1
     * @environment: 环境贴图，默认是 'city'
     * @contactShadowOpacity: 接触阴影的不透明度，默认是 0.25
     * @contactShadowBlur: 接触阴影的模糊程度，默认是 1
     * @adjustCamera: 是否调整相机，默认是 true
     */

    /**
     * OrbitControls 组件是一个控制器，可以通过 ref 来获取
     * @target: 控制器的焦点，默认是 (0, 0, 0)
     * @update: 控制器更新时的回调函数
     * @autoRotate: 是否自动旋转，默认是 false
     * @enablePan: 是否开启平移，默认是 true
     * @enableZoom: 是否开启缩放，默认是 true
     * @enableRotate: 是否开启旋转，默认是 true
     * @enableDamping: 是否开启阻尼，默认是 true
     * @dampingFactor: 阻尼系数，默认是 0.05
     * @rotateSpeed: 旋转速度，默认是 1
     * @zoomSpeed: 缩放速度，默认是 1
     * @panSpeed: 平移速度，默认是 1
     * @minDistance: 最小距离，默认是 0
     * @maxDistance: 最大距离，默认是 Infinity
     * @minPolarAngle: 最小极角，默认是 0
     * @maxPolarAngle: 最大极角，默认是 Math.PI
     * @minAzimuthAngle: 最小方位角，默认是 -Infinity
     * @maxAzimuthAngle: 最大方位角，默认是 Infinity
     * @enableKeys: 是否开启键盘控制，默认是 true
     * @keys: 键盘控制的键位，默认是 { LEFT: 37, UP: 38, RIGHT: 39, BOTTOM: 40 }
     * @mouseButtons: 鼠标控制的键位，默认是 { LEFT: MOUSE.ROTATE, MIDDLE: MOUSE.DOLLY, RIGHT: MOUSE.PAN }
     */

    /**
     * environment设置空，避免加载用不到的环境资源，且可能因为跨域导致失败
     * 默认的环境贴图是 'city'，会加载一个动态范围 (HDR) 光栅图像文件
     * https://github.com/pmndrs/assets/tree/main/src/hdri
     */

    <Canvas
      shadows={false}
      dpr={[1, 2]}
      camera={{ position: [0, 0, 10], fov: 30 }}
    >
      <Suspense fallback={<Progress />}>
        <Stage controls={ref} intensity={1} environment="">
          {/* {type === 'gltf' ? (
            <GLTFModel source={source} />
          ) : (
            <PLYModel source={source} />
          )} */}
          <PLYModel source={source} />
        </Stage>
      </Suspense>
      <OrbitControls ref={ref} autoRotate />
    </Canvas>
  )
}

export default ThreeModelViewer
